<template>
  <div class="py-4 px-5">
    <v-card elevation="0">
      <v-row align="start" justify="space-between">
        <v-col md="2">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                @click="backModal()"
                v-on="on"
                fab
                small
                dark
                color="grey"
                class="mr-2"
                depressed
              >
                <v-icon dark>keyboard_arrow_left</v-icon>
              </v-btn>
            </template>
            <span>Back</span>
          </v-tooltip>
        </v-col>

        <v-col md="2" class="text-right">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn @click="add()" v-on="on" small dark color="primary" depressed>Save</v-btn>
            </template>
            <span>Submit</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card>

    <v-form ref="addForm" lazy-validation>
      <v-text-field
        v-model="form.name"
        :rules="normalValidation"
        name="Name"
        label="Name"
        required
        validate-on-blur
        type="text"
      ></v-text-field>
      <v-text-field
        v-model="form.sku"
        :rules="normalValidation"
        name="SKU"
        label="SKU"
        required
        validate-on-blur
        type="text"
      ></v-text-field>
      <v-text-field v-model="form.gtin" name="Gtin" label="Gtin" validate-on-blur type="text"></v-text-field>
      <v-text-field
        v-model="form.weight_equivalent_dry_cannabis"
        :rules="decimalValidation"
        name="Weight equivalent to dry cannabis"
        label="Weight equivalent to dry cannabis"
        validate-on-blur
        type="text"
      ></v-text-field>
      <v-text-field
        v-model="form.price"
        :rules="decimalValidation"
        name="Price"
        label="Price"
        required
        validate-on-blur
        type="numeric"
      ></v-text-field>
      <v-text-field
        v-model="form.sale_price"
        :rules="decimalValidation"
        name="Sale Price"
        label="Sale Price"
        required
        validate-on-blur
        type="numeric"
      ></v-text-field>
      <v-text-field
        v-model="form.size"
        :rules="normalValidation"
        name="Size"
        label="Size"
        required
        validate-on-blur
        type="text"
      ></v-text-field>
      <v-text-field
        v-model="form.no_of_units"
        :rules="numericValidation"
        name="No of units"
        label="No of units"
        required
        validate-on-blur
        type="numeric"
      ></v-text-field>
      <v-text-field
        v-model="form.inventory_threshold"
        :rules="numericValidation"
        name="Inventory Threshold"
        label="Inventory Threshold"
        required
        validate-on-blur
        type="numeric"
      ></v-text-field>
      <v-text-field
        v-model="form.bar_code"
        :rules="normalValidation"
        name="Bar code"
        label="Bar code"
        required
        validate-on-blur
        type="text"
      ></v-text-field>
      <v-switch v-model="form.available" name="Available" label="Available" color="primary"></v-switch>
    </v-form>
  </div>
</template>

<script>
import { LocationProductAPI } from '@/clients/location/location.product.api'
import Helper from '@/utility/Helpers'
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      normalValidation: [
        v => !!v || 'Field is required'
      ],
      numericValidation: [
        (v) => /^[0-9]+$/.test(v) || 'Field must be numeric'
      ],
      decimalValidation: [
        (v) => !!v || 'Field is required',
        v => v !== 0 || 'Must be greater than 0.',
        (v) => /^\d+(\.\d{1,2})?$/.test(v) || 'Field must be numeric'
      ],
      form: {
        name: '',
        sku: '',
        gtin: '',
        price: '',
        sale_price: '',
        weight_equivalent_dry_cannabis: '',
        size: '',
        no_of_units: '',
        inventory_threshold: '',
        bar_code: '',
        available: false
      }
    }
  },

  computed: {
    ...mapGetters({
      activeItem: 'locationproduct/activeItem',
      variantItems: 'locationproduct/variantsList'
    })
  },

  methods: {
    /**
     * Add new data
     */
    async add() {
      if (this.$refs['addForm'].validate()) {
        try {
          this.spinner(true)
          let res = await LocationProductAPI.insertVariant(this.activeItem.id, this.form)
          this.spinner(false)
          if (res.status === 200) {
            // reset form
            this.form = Helper.setObjValueEmpty(this.form)
            this.backModal()
          }
          // Display message alert
          this.snackbar({
            text: res.status === 200 ? res.data.msg : res.response.data.errors ? res.response.data.errors[0] : res.response.data.msg,
            open: true,
            color: res.status === 200 ? 'success' : 'error'
          })
        } catch (err) {
          this.spinner(false)
          this.snackbar({
            text: err.response.data.errors ? err.response.data.errors[0] : err.response.data.message,
            open: true,
            color: 'error'
          })
        }
      }
    },

    /**
     * Close add  popup
     */
    backModal() {
      this.setVariantsPopUpType('list')
    },

    ...mapActions({
      setVariantsPopUpType: 'locationproduct/setVariantsPopUpType'
    })
  }
}
</script>
